//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UserAccessLogDetail from '@/modules/tasks/tableau/components/user-access/UserAccessLogDetail';
import TableauUserAccessService from '@/apps/data-platform/services/visualization/tableauRol';
export default {
  name: 'UserAccessLogs',
  components: {
    UserAccessLogDetail: UserAccessLogDetail
  },
  props: {
    record: {
      type: Object,
      require: true,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      items: [],
      dateFrom: '',
      dateTo: new Date().toISOString().slice(0, 10),
      currentViewPage: 1
    };
  },
  created: function created() {
    this.getItems();
  },
  computed: {
    fields: function fields() {
      return [{
        value: 'created_date',
        text: this.traductor('tablas.creation_time'),
        class: 'text-center w-40',
        sortable: true
      }, {
        value: 'created_by',
        text: this.traductor('tablas.created_by'),
        sortable: true
      }, {
        value: 'tableau_rol',
        text: this.traductor('tablas.values'),
        class: 'w-20',
        sortable: true
      }, {
        value: 'type_id',
        text: this.traductor('tablas.type'),
        sortable: true
      }];
    },
    form: function form() {
      return {
        user: this.traductor('tablas.user'),
        groups: this.traductor('tablas.groups'),
        from: this.traductor('form_audiencia.desde'),
        to: this.traductor('form_audiencia.hasta')
      };
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    getItems: function getItems() {
      var _this = this;
      var params = {
        record: {
          document_id: this.record.name,
          date_from: this.dateFrom,
          date_to: this.dateTo
        }
      };
      TableauUserAccessService.logTableauRol(params).then(function (response) {
        _this.items = response.data.result;
      });
    }
  }
};